/*
 * @Descripttion: 工具集
 * @version: 1.2
 * @LastEditors: nda
 * @LastEditTime: 2026年01月04日 11:05:25
 */

import { Message } from 'element-ui';

const tool = {}

tool.copyText = (text) => {
	// 创建隐藏的 textarea 元素
	const textarea = document.createElement("textarea");
	textarea.value = text;
	textarea.style.position = "fixed";
	textarea.style.left = "-9999px";
	document.body.appendChild(textarea);

	// 选中内容并复制
	textarea.select();
	textarea.setSelectionRange(0, text.length);

	try {
		const successful = document.execCommand("copy");
		if (successful) {
			Message.success("复制成功");
		} else {
			Message.error("复制失败，请手动复制");
		}
	} catch (error) {
		console.log("复制错误", error);
		Message.error("复制错误");
	} finally {
		document.body.removeChild(textarea);
	}
}

// token 操作
tool.token = {
	set(token) {
		localStorage.setItem('token', token);
	},
	get() {
		return localStorage.getItem('token');
	},
	remove() {
		localStorage.removeItem('token');
	}
}

export default tool
